import {
  makeFactorRows,
  makeFactorHeaders,
  getSummaryValue,
  makeExpEstRow,
  makeExpEstHeaders,
  getTitle,
  buildDisplayText,
  makeModelTable,
} from '../utils'

import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { mapUnitOrOriginal } from '@/components/combined-predict/components/CombinedPredictTable/utils/unitConversions'

const modelSummaryMapper = (mp, bp, metaMp, metaBp) => {
  const mpUnit = mapUnitOrOriginal(metaMp?.unit)
  const bpUnit = mapUnitOrOriginal(metaBp?.unit)

  const selectedMpValue = getSummaryValue(mp?.selectedValue ?? mp?.predicted, getTitle(metaMp))
  const selectedBpValue = getSummaryValue(bp?.selectedValue ?? bp?.predicted, getTitle(metaBp))

  return {
    values: [selectedMpValue, selectedBpValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [
          makeExpEstRow(
            mp?.experimental,
            mp?.predicted,
            buildDisplayText({ mainText: getTitle(metaMp), secondaryText: mpUnit }),
          ),
          makeExpEstRow(
            bp?.experimental,
            bp?.predicted,
            buildDisplayText({ mainText: getTitle(metaBp), secondaryText: bpUnit }),
          ),
        ],
      },
    ],
  }
}

const modelDescriptorsMapper = (mp, bp) => {
  const modelMp = mp?.predicted?.model
  const modelBp = bp?.predicted?.model
  const meltingPointTable = makeModelTable(modelMp, 'Melting Point (Adapted Joback / Gold-Ogle Methods)')
  const boilingPointTable = makeModelTable(modelBp, 'Boiling Point (Adapted Stein and Brown Method)')

  return {
    tables: [meltingPointTable, boilingPointTable],
  }
}

const mpbp = (items) => {
  const meltingPoint = items?.find((item) => item?.property === 'meltingPoint')
  const boilingPoint = items?.find((item) => item?.property === 'boilingPoint')
  const metaMeltingPoint = findEpiSuiteGroupById('meltingPoint')
  const metaBoilingPoint = findEpiSuiteGroupById('boilingPoint')

  return {
    title: `${getTitle(metaMeltingPoint)}${getTitle(metaBoilingPoint)}`,
    description: `${metaMeltingPoint?.description ?? metaMeltingPoint?.name} / ${metaBoilingPoint?.description ?? metaBoilingPoint?.name}`,
    helpPage: metaMeltingPoint?.helpPage,
    summary: modelSummaryMapper(meltingPoint, boilingPoint, metaMeltingPoint, metaBoilingPoint),
    modelDescriptors: modelDescriptorsMapper(meltingPoint, boilingPoint),
    modelOutput: null,
  }
}

export { mpbp }
